module.exports = __webpack_public_path__ + "media/images/default/pages/about/clinic-3-802bf8341c7a914bd84a52e62b35fde8.jpeg";